import styled from 'styled-components/macro';

export const ErrorContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 6rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-left: 0;
  }
`;

export const Header = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme }) => theme.colors.black_100};

  font-size: ${({ theme }) => theme.fontSize.xl};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  line-height: ${({ theme }) => theme.lineHeight.one_1};
`;

export const Message = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.two};

  color: ${({ theme }) => theme.colors.black_100};

  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  text-align: center;
`;

export const Email = styled.a<{
  fontSize?: string;
  fontFamily?: string;
  letterSpacing?: string;
  color?: string;
}>`
  font-size: ${({ fontSize, theme }) => (fontSize ? fontSize : theme.fontSize.md)};
  font-family: ${({ fontFamily, theme }) => (fontFamily ? fontFamily : theme.fontFamily.semiBold)};
  letter-spacing: ${({ letterSpacing, theme }) =>
    letterSpacing ? letterSpacing : theme.letterSpacing.sm};
  color: ${({ color }) => color && color};
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing.zero_2};
  cursor: pointer;
`;
